import type {Call} from '../../store/features/calls/callsService';
import {getFullName} from '../../utilis/getFullName';
import {getFormatedPhoneNumber} from '../../utilis/msisdnUtilis';

export type CallDirection = 'incoming' | 'outgoing' | 'missed-outgoing' | 'missed' | 'forwarded';

/** What the list row and the details header show for one call. */
export interface CallRowView {
    direction: CallDirection;
    /** Badge word; the state is never shown by colour alone. */
    directionLabel: string;
    missed: boolean;
    /** Contact, colleague or the formatted number. */
    name: string;
    /** The caller's number when the name is a person, so the row shows both. */
    number?: string;
    known: boolean;
    internal: boolean;
    spam: boolean;
}

const LABELS: Record<CallDirection, string> = {
    incoming: 'Incoming',
    outgoing: 'Outgoing',
    'missed-outgoing': 'Missed outgoing',
    missed: 'Missed',
    forwarded: 'Forwarded',
};

export function callDirection(call: Pick<Call, 'type' | 'bridgetAt' | 'finishedAt' | 'forwardedTo' | 'forwardedAt'>): CallDirection {
    if (call.forwardedTo || call.forwardedAt) return 'forwarded';
    if (call.type === 'OUTBOUND') return call.finishedAt && !call.bridgetAt ? 'missed-outgoing' : 'outgoing';
    if (call.type === 'INBOUND' && !call.bridgetAt) return 'missed';
    return 'incoming';
}

export function callRowView(call: Call): CallRowView {
    const direction = callDirection(call);
    const number = call.clientMsisdn ? getFormatedPhoneNumber(call.clientMsisdn, true) ?? undefined : undefined;
    const person = call.internalCallee ?? (call.primaryContact ?? null);
    const name = person ? getFullName(person.firstName, person.lastName) : number ?? 'Unknown';
    return {
        direction,
        directionLabel: LABELS[direction],
        missed: direction === 'missed',
        name,
        number: person && !call.internalCallee ? number : undefined,
        known: Boolean(person),
        internal: Boolean(call.internalCallee),
        spam: Boolean(call.spamCaller),
    };
}
